var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100vh"}},[_c('span',{staticStyle:{"padding":"10px"}},[_vm._v("404 PAGE NOT FOUND!")])])}]

export { render, staticRenderFns }